import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { formatTimeforCallTimer } from 'features/call/call-timer/components/';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

interface CallTimerProps {
  duration: number;
}

export const CallTimer: FC<CallTimerProps> = ({ duration }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'callTimer',
  });

  return (
    <Container>
      <Typography variant='label' color={theme.palette.grey[100]}>
        {t('title')}
      </Typography>
      <Typography
        data-testid='call-timer'
        variant='body1'
        color={theme.palette.common.white}
      >
        {formatTimeforCallTimer(duration)}
      </Typography>
    </Container>
  );
};

const Container = styled('div')`
  display: flex;
  flex-direction: column;
`;
